import { AuthManager } from "@bytescale/sdk"
import { useEffect } from "react"

import useUser from "@hooks/useUser"

import { BYTESCALE_ENDPOINTS } from "@endpoints/bytescale"

const BYTESCALE_AUTH_SERVICE_WORKER_PATH = "/bytescale-auth-sw.js"

export default function useBytescaleAuthSession() {
    const { user } = useUser()

    const hasServiceCompany = !!user?.service_company?.slug

    useEffect(() => {
        if (!hasServiceCompany || AuthManager.isAuthSessionActive()) {
            return
        }

        const accountId = process.env.BYTESCALE_ACCOUNT_ID
        if (!accountId) {
            console.error("Missing BYTESCALE_ACCOUNT_ID environment variable")
            return
        }

        // Authenticates Bytescale CDN requests (HLS manifests/segments, private file URLs) for the
        // whole page. The session outlives this component and is ended explicitly on logout.
        AuthManager.beginAuthSession({
            accountId,
            authUrl: BYTESCALE_ENDPOINTS.JWT,
            authHeaders: () => Promise.resolve({}),
            serviceWorkerScript: BYTESCALE_AUTH_SERVICE_WORKER_PATH,
        }).catch((error) => {
            console.warn("Unable to begin Bytescale auth session:", error)
        })
    }, [hasServiceCompany])
}
